import { skipToken, useQuery } from '@tanstack/react-query';

import { Collections } from '@air/api';
import { type ApiResponse, callAirApi } from '@air/utils-api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

type GetCollectionResponse = ApiResponse<typeof Collections.get>;

export type CollectionInput = {
  collectionId: string;
};

export const COLLECTION_KEY = 'COLLECTION_KEY';
export type CollectionKey = [typeof COLLECTION_KEY, CollectionInput];

export const getCollectionKey = (params: CollectionInput): CollectionKey => [
  COLLECTION_KEY,
  { collectionId: params.collectionId },
];

export const useGetCollection = ({ collectionId }: CollectionInput) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;

  return useQuery({
    queryKey: getCollectionKey({ collectionId }),
    queryFn:
      collectionId && workspaceId
        ? () => callAirApi<GetCollectionResponse>(() => Collections.get({ workspaceId, collectionId }))
        : skipToken,
    enabled: !!collectionId && !!workspaceId,
  });
};
